<template lang="pug">
.redesign

  the-header(v-if="!$route.meta.noHeader")
  v-main.v-main__wrap(
    color="#F1F2F6"
  )
    app-drawer(v-if="$route.meta.subdrawer")
    .container(
      v-if="!$route.meta.preventLayoutTemplate"
      :class="{ 'fluid': $route.meta.fluidContainer }"
    )
      text-loader(v-show="loading")
      div(v-show="!loading")
        .page__navigation(
          v-if="$route.meta.navigation"
          :class=`{
            'mt-16': !$route.meta.navigation.breadcrumbs,
            'mt-10': $route.meta.navigation.breadcrumbs,
          }`
        )
          .page__navigation__breadcrumbs(
            v-if="$route.meta.navigation.breadcrumbs"
          )
            template(
              v-for="(item, idx) in breadcrumbs"
            )
              span(v-if="idx") /
              router-link.page__navigation__breadcrumbs__item(
                :to="item.to"
              ) {{ item.text }}
          .page__navigation__back(
            v-if="$route.meta.navigation.back"
            @click="routerGoBack"
          )
            v-icon(
              color="redesignPrimary"
              :size="20"
              left
            ) $iarrow-left
            | Назад
        h4.page__title(
          :class="{ 'mt-8': $route.meta.navigation }"
        ) {{ $route.meta.title }}
        slot
    .full-width(v-else)
      slot
</template>

<script>
import TheHeader from '@/components/user-redesign/layout/TheHeader/TheHeader.vue';
import TextLoader from '@/components/user-redesign/layout/TextLoader.vue';
import AppDrawer from '@/components/user-redesign/layout/AppDrawer.vue';

export default {
  components: {
    TheHeader,
    TextLoader,
    AppDrawer,
  },

  provide() {
    return {
      setLoading: this.setLoading,
      setBreadcrumbs: this.setBreadcrumbs,
    };
  },

  data() {
    return {
      loading: false,
      breadcrumbs: [],
      darkTheme: false,
    };
  },

  watch: {
    '$route.path': {
      handler() {
        this.breadcrumbs = [];
      },
    },
    darkTheme(v) {
      this.$vuetify.theme.dark = v;
    },
  },

  methods: {
    setLoading(state) {
      this.loading = state;
    },
    setBreadcrumbs(items) {
      this.breadcrumbs = items;
    },
    routerGoBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
@import '@/styles/scss/redesign.scss';

.theme--light.v-application:has(.redesign) {
  background-color: #{$redesignBackground};
}

.redesign {
  font-family: Inter;
}
.v-main__wrap {
  display: flex;
  background-color: #{$redesignBackground};
}
.page-subdrawer {
  width: 260px;
}
.page__title {
  margin-top: 64px;
  margin-bottom: 20px;
  color: #{$redesignPrimaryDarken};
  font-family: Inter;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: none;
}
.page__navigation {
  &__back {
    display: inline;
    cursor: pointer;
    font-size: 16px;
    line-height: 19px;

    transition: all 0.2s;
    &:active {
      transform: scale(0.95);
    }
    &:hover {
      color: #{$redesignPrimary};
    }
  }

  &__breadcrumbs {
    margin-bottom: 16px;
    display: flex;
    gap: 8px;

    &__item {
      transition: all 0.2s;
      &:hover {
        color: #{$redesignPrimary};
      }
    }
  }
}
.custom-application--wrap {
  height: calc(100vh - 40px);
  margin: 20px;
  border-radius: 25px;
  background: #f5f6fbb5;
  overflow: auto;
  z-index: 1;

  @media screen and (max-width: 768px) {
    margin: 0;
    height: 100vh;
    border-radius: 0;
  }
}
</style>
